// Central content for HollowCorp (FR)
export const BRAND = {
  name: "HollowCorp",
  tagline: "Studio de création web",
  legalForm: "Entrepreneur individuel — Micro-entreprise",
  ape: "6201Z — Programmation informatique",
  email: "issa.horth@hollowcorp.fr",
  phone: "+33 6 20 92 72 60",
  phoneRaw: "+33620927260",
  address: "7 Avenue des Rouges Gorges, 91360 Villemoisson-sur-Orge, France",
  siret: "107 939 530 00013",
  siren: "107 939 530",
  socials: {
    tiktok: { handle: "Hollow_corp.official", url: "https://www.tiktok.com/@hollow_corp.official" },
    instagram: { handle: "hollowcorp.official", url: "https://www.instagram.com/hollowcorp.official" },
  },
};

export const SERVICES = [
  {
    id: "01",
    title: "Création de sites",
    desc: "Des sites vitrines et e-commerce sur-mesure, pensés pour convertir. Design distinctif, performance et responsive absolu.",
    tags: ["Vitrine", "E-commerce", "Sur-mesure"],
  },
  {
    id: "02",
    title: "Refonte & modernisation",
    desc: "Votre site actuel est daté ? On le repense de fond en comble : identité, structure et expérience, sans perdre votre référencement.",
    tags: ["Redesign", "Migration", "UX"],
  },
  {
    id: "03",
    title: "Applications web",
    desc: "Des outils web robustes et évolutifs : espaces membres, tableaux de bord, réservations, back-office. Du concept au déploiement.",
    tags: ["Full-stack", "Dashboard", "SaaS"],
  },
  {
    id: "04",
    title: "Conseil & maintenance",
    desc: "Accompagnement stratégique, mises à jour de sécurité et suivi continu. On garde votre présence en ligne rapide et fiable.",
    tags: ["Conseil", "Sécurité", "Support"],
  },
];

export const OFFERS = {
  vitrine: {
    id: "vitrine",
    first: 99,
    recurring: 35,
    currency: "€",
  },
  webapp: {
    id: "webapp",
    first: 249,
    recurring: 89,
    currency: "€",
  },
};

export const MANIFESTO = [
  {
    num: "01",
    title: "Le web sans compromis",
    body: "Nous ne livrons pas des templates. Chaque projet est une pièce unique, construite pour votre marque et vos objectifs.",
  },
  {
    num: "02",
    title: "Deux formules, zéro surprise",
    body: "Site vitrine ou web app : hébergement, domaine, sécurité et suivi inclus. Le prix suit le temps et les ressources vraiment nécessaires.",
  },
  {
    num: "03",
    title: "Proche et réactive",
    body: "Un interlocuteur unique, à l'écoute. Vos modifications sont prises en compte quand vous en avez besoin, sans jargon.",
  },
  {
    num: "04",
    title: "Fait pour durer",
    body: "Des sites rapides, sûrs et évolutifs. On pense performance, référencement et maintenance dès la première ligne de code.",
  },
];

export const WORKS = [
  {
    title: "L'Atelier du Quai",
    category: "Site vitrine — exemple HollowCorp",
    href: "/fr/exemples/vitrine",
    hrefEn: "/en/examples/showcase",
    img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1400&q=80",
    year: "2026",
  },
  {
    title: "HollowCorp",
    category: "Web app",
    href: "/",
    hrefEn: "/en/home",
    img: "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=1400&q=80",
    year: "2026",
  },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1654198340681-a2e0fc449f1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const ABOUT_IMG = "https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
